export default __webpack_public_path__ + "static/media/picture2.44c2d6b1.png";